/* eslint-disable no-case-declarations */
import { CustomEmailTemplateApiPayloadType } from 'screens/Products/Plural/PaymentLinks/components/CustomizePaymentLinks/components/CustomEmailTemplate/typing';
import actionConstants from '../constants/';

const getPaymentLinksList = {
  isLoading: false,
  isSuccess: false,
  isFailure: false,
  errorCode: 0,
  data: {},
  errorMessage: '',
};

const getEdgePaymentLinksList = {
  isLoading: false,
  isSuccess: false,
  isFailure: false,
  errorCode: 0,
  data: {},
  errorMessage: '',
};

const getEdgeV3PaymentLinksList = {
  isLoading: false,
  isSuccess: false,
  isFailure: false,
  errorCode: 0,
  data: {},
  errorMessage: '',
};

const managePaymentLinkState = {
  isLoading: false,
  isSuccess: false,
  isFailure: false,
  responseCode: 0,
  responseMessage: '',
  data: {},
  errorDetails: [],
};

const cancelPaymentLinkState = {
  isLoading: false,
  isSuccess: false,
  isFailure: false,
  responseCode: 0,
  responseMessage: '',
};

const bulkUploadHistoryState = {
  isLoading: false,
  isSuccess: false,
  isFailure: false,
  errorCode: 0,
  data: [],
  errorMessage: '',
};

const statusCodeMappingState = {
  isLoading: false,
  isSuccess: false,
  isFailure: false,
  errorCode: 0,
  data: [],
  errorMessage: '',
};

const merchantAllUDFList = {
  isLoading: false,
  isSuccess: false,
  isFailure: false,
  errorCode: 0,
  data: [],
  errorMessage: '',
};

const merchantAllEdgeUDFList = {
  isLoading: false,
  isSuccess: false,
  isFailure: false,
  errorCode: 0,
  data: [],
  errorMessage: '',
};
const paymentLinksCustomizationState = {
  isLoading: false,
  isSuccess: false,
  isFailure: false,
  responseCode: 0,
  data: [],
  responseMessage: '',
  isSubscribed: false,
};

const edgePaymentLinksCustomizationState = {
  isLoading: false,
  isSuccess: false,
  isFailure: false,
  responseCode: 0,
  data: [],
  responseMessage: '',
  enable: false,
};

const updateAllUDFListState = {
  isLoading: false,
  isSuccess: false,
  isFailure: false,
  errorCode: 0,
  data: [],
  errorMessage: '',
};
const updateAllEdgeUDFListState = {
  isLoading: false,
  isSuccess: false,
  isFailure: false,
  errorCode: 0,
  data: [],
  errorMessage: '',
};

const availablePaymentModeListState = {
  isLoading: false,
  isSuccess: false,
  isFailure: false,
  errorCode: 0,
  data: [],
  errorMessage: '',
};

const customEmailTemplateState = {
  isLoading: false,
  isSuccess: false,
  isFailure: false,
  errorCode: 0,
  errorMessage: '',
  defaultDataObj: {},
  currentDataObj: {},
};
const customEdgeEmailTemplateState = {
  isLoading: false,
  isSuccess: false,
  isFailure: false,
  errorCode: 0,
  errorMessage: '',
  defaultDataObj: {},
  currentDataObj: {},
};

const manageCustomEmailTemplateState = {
  isLoading: false,
  isSuccess: false,
  isFailure: false,
  responseCode: 0,
  responseMessage: '',
};
const manageEdgeCustomEmailTemplateState = {
  isLoading: false,
  isSuccess: false,
  isFailure: false,
  responseCode: 0,
  responseMessage: '',
};

const fetchPaymentLinkDetails = {
  isLoading: false,
  isSuccess: false,
  isFailure: false,
  errorCode: 0,
  data: {},
  errorMessage: '',
};

const merchantConfigList = {
  isLoading: false,
  isSuccess: false,
  isFailure: false,
  errorCode: 0,
  data: {},
  errorMessage: '',
};

const initialState = {
  paymentLinksList: { ...getPaymentLinksList },
  edgePaymentLinksList: { ...getEdgePaymentLinksList },
  managePaymentLinkState: { ...managePaymentLinkState },
  bulkUploadHistoryState: { ...bulkUploadHistoryState },
  statusCodeMappingState: { ...statusCodeMappingState },
  merchantAllUDFList: { ...merchantAllUDFList },
  merchantAllEdgeUDFList: { ...merchantAllEdgeUDFList },
  paymentLinksCustomizationState: { ...paymentLinksCustomizationState },
  edgePaymentLinksCustomizationState: { ...edgePaymentLinksCustomizationState },
  updateAllUDFListState: { ...updateAllUDFListState },
  updateAllEdgeUDFListState: { ...updateAllEdgeUDFListState },
  availablePaymentModeListState: { ...availablePaymentModeListState },
  cancelPaymentLinkState: { ...cancelPaymentLinkState },
  customEmailTemplateState: { ...customEmailTemplateState },
  customEdgeEmailTemplateState: { ...customEdgeEmailTemplateState },
  manageCustomEmailTemplateState: { ...manageCustomEmailTemplateState },
  fetchPaymentLinkDetails: { ...fetchPaymentLinkDetails },
  merchantConfigList: { ...merchantConfigList },
  manageEdgeCustomEmailTemplateState: { ...manageEdgeCustomEmailTemplateState },
  edgeV3PaymentLinksList: { ...getEdgeV3PaymentLinksList },
};

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export default function paymentLinksReducer(state = initialState, action) {
  switch (action.type) {
    case actionConstants.GET_PAYMENT_LINKS_LIST_REQUEST:
      return {
        ...state,
        paymentLinksList: {
          ...state.paymentLinksList,
          isLoading: true,
          isSuccess: false,
          isFailure: false,
          errorCode: 0,
        },
      };
    case actionConstants.GET_PAYMENT_LINKS_LIST_SUCCESS:
      return {
        ...state,
        paymentLinksList: {
          ...state.paymentLinksList,
          isLoading: false,
          isSuccess: true,
          isFailure: false,
          data: action.payload.body,
          // errorCode: action.payload.OpCode,
        },
      };

    case actionConstants.GET_PAYMENT_LINKS_LIST_FAILURE:
      return {
        ...state,
        paymentLinksList: {
          ...state.paymentLinksList,
          isLoading: false,
          isSuccess: false,
          isFailure: true,
          // errorCode: action.payload.OpCode,
        },
      };

    case actionConstants.GET_PAYMENT_LINKS_LIST_CLEAR:
      return {
        ...state,
        paymentLinksList: {
          ...initialState.paymentLinksList,
          data: {},
        },
      };

    case actionConstants.GET_EDGE_PAYMENT_LINKS_LIST_REQUEST:
      return {
        ...state,
        edgePaymentLinksList: {
          ...state.edgePaymentLinksList,
          isLoading: true,
          isSuccess: false,
          isFailure: false,
          errorCode: 0,
        },
      };
    case actionConstants.GET_EDGE_PAYMENT_LINKS_LIST_SUCCESS:
      return {
        ...state,
        edgePaymentLinksList: {
          ...state.edgePaymentLinksList,
          isLoading: false,
          isSuccess: true,
          isFailure: false,
          data: action.payload.body,
          // errorCode: action.payload.OpCode,
        },
      };

    case actionConstants.GET_EDGE_PAYMENT_LINKS_LIST_FAILURE:
      return {
        ...state,
        edgePaymentLinksList: {
          ...state.edgePaymentLinksList,
          isLoading: false,
          isSuccess: false,
          isFailure: true,
          // errorCode: action.payload.OpCode,
        },
      };

    case actionConstants.GET_EDGE_PAYMENT_LINKS_LIST_CLEAR:
      return {
        ...state,
        edgePaymentLinksList: {
          ...initialState.edgePaymentLinksList,
          data: {},
        },
      };
    
    // Edge V3 Payment Link List 
    
    case actionConstants.GET_EDGE_V3_PAYMENT_LINKS_LIST_REQUEST:
      return {
        ...state,
        edgeV3PaymentLinksList: {
          ...state.edgeV3PaymentLinksList,
          isLoading: true,
          isSuccess: false,
          isFailure: false,
          errorCode: 0,
        },
      };
    case actionConstants.GET_EDGE_V3_PAYMENT_LINKS_LIST_SUCCESS:
      return {
        ...state,
        edgeV3PaymentLinksList: {
          ...state.edgeV3PaymentLinksList,
          isLoading: false,
          isSuccess: true,
          isFailure: false,
          data: action.payload.body,
        },
      };

    case actionConstants.GET_EDGE_V3_PAYMENT_LINKS_LIST_FAILURE:
      return {
        ...state,
        edgeV3PaymentLinksList: {
          ...state.edgeV3PaymentLinksList,
          isLoading: false,
          isSuccess: false,
          isFailure: true,
        },
      };

    case actionConstants.GET_EDGE_V3_PAYMENT_LINKS_LIST_CLEAR:
      return {
        ...state,
        edgeV3PaymentLinksList: {
          ...initialState.edgeV3PaymentLinksList,
          data: {},
        },
      };


    // Create Payment Link
    case actionConstants.MANAGE_PAYMENT_LINK_REQUEST:
      return {
        ...state,
        managePaymentLinkState: {
          ...state.managePaymentLinkState,
          isLoading: true,
          isSuccess: false,
          isFailure: false,
          responseCode: 0,
          responseMessage: '',
          errorDetails: [],
        },
      };
    case actionConstants.MANAGE_PAYMENT_LINK_SUCCESS:
      return {
        ...state,
        managePaymentLinkState: {
          ...state.managePaymentLinkState,
          isLoading: false,
          isSuccess: true,
          isFailure: false,
          responseCode: action.payload?.body?.response_code ?? 0,
          responseMessage: action.payload?.body?.response_message ?? '',
          data: action.payload?.body ?? {},
          errorDetails: [],
        },
      };

    case actionConstants.MANAGE_PAYMENT_LINK_FAILURE:
      return {
        ...state,
        managePaymentLinkState: {
          ...state.managePaymentLinkState,
          isLoading: false,
          isSuccess: false,
          isFailure: true,
          responseCode: action.payload?.body?.error_code
            ? action.payload?.body?.error_code
            : action.payload?.body?.errorCode
            ? action.payload?.body?.errorCode
            : 0,

          responseMessage: action.payload?.body?.error_message
            ? action.payload?.body?.error_message
            : action.payload?.body?.errorMessage
            ? action.payload?.body?.errorMessage
            : '',
          errorDetails: action.payload?.body?.errorDetails ?? [],
        },
      };

    case actionConstants.MANAGE_PAYMENT_LINK_CLEAR:
      return {
        ...state,
        managePaymentLinkState: {
          ...initialState.managePaymentLinkState,
          data: {},
        },
      };

    // Cancel Payment Link
    case actionConstants.POST_CANCEL_PAYMENT_LINK_REQUEST:
      return {
        ...state,
        cancelPaymentLinkState: {
          ...state.cancelPaymentLinkState,
          isLoading: true,
          isSuccess: false,
          isFailure: false,
          responseCode: 0,
          responseMessage: '',
        },
      };
    case actionConstants.POST_CANCEL_PAYMENT_LINK_SUCCESS:
      return {
        ...state,
        cancelPaymentLinkState: {
          ...state.cancelPaymentLinkState,
          isLoading: false,
          isSuccess: true,
          isFailure: false,
          responseCode: action.payload?.body?.response_code ?? 0,
          responseMessage: action.payload?.body?.response_message ?? '',
        },
      };

    case actionConstants.POST_CANCEL_PAYMENT_LINK_FAILURE:
      return {
        ...state,
        cancelPaymentLinkState: {
          ...state.cancelPaymentLinkState,
          isLoading: false,
          isSuccess: false,
          isFailure: true,
          responseCode: action.payload?.body?.error_code
            ? action.payload?.body?.error_code
            : action.payload?.body?.errorCode
            ? action.payload?.body?.errorCode
            : 0,

          responseMessage: action.payload?.body?.error_message
            ? action.payload?.body?.error_message
            : action.payload?.body?.errorMessage
            ? action.payload?.body?.errorMessage
            : '',
        },
      };

    case actionConstants.POST_CANCEL_PAYMENT_LINK_CLEAR:
      return {
        ...state,
        cancelPaymentLinkState: {
          ...initialState.cancelPaymentLinkState,
          data: {},
        },
      };

    case actionConstants.GET_PAYMENT_LINK_BULK_UPLOAD_HISTORY_REQUEST:
      return {
        ...state,
        bulkUploadHistoryState: {
          ...state.bulkUploadHistoryState,
          isLoading: true,
          isSuccess: false,
          isFailure: false,
          errorCode: 0,
        },
      };

    case actionConstants.GET_PAYMENT_LINK_BULK_UPLOAD_HISTORY_SUCCESS:
      return {
        ...state,
        bulkUploadHistoryState: {
          ...state.bulkUploadHistoryState,
          isLoading: false,
          isSuccess: true,
          isFailure: false,
          data: action.payload.body,
          // errorCode: action.payload.OpCode,
        },
      };

    case actionConstants.GET_PAYMENT_LINK_BULK_UPLOAD_HISTORY_FAILURE:
      return {
        ...state,
        bulkUploadHistoryState: {
          ...state.bulkUploadHistoryState,
          isLoading: false,
          isSuccess: false,
          isFailure: true,
          // errorCode: action.payload.OpCode,
        },
      };

    case actionConstants.GET_PAYMENT_LINK_BULK_UPLOAD_HISTORY_CLEAR:
      return {
        ...state,
        bulkUploadHistoryState: {
          ...initialState.bulkUploadHistoryState,
          data: [],
        },
      };

    case actionConstants.GET_PAYMENT_LINK_STATUS_CODE_REQUEST:
      return {
        ...state,
        statusCodeMappingState: {
          ...state.statusCodeMappingState,
          isLoading: true,
          isSuccess: false,
          isFailure: false,
          errorCode: 0,
        },
      };

    case actionConstants.GET_PAYMENT_LINK_STATUS_CODE_SUCCESS:
      return {
        ...state,
        statusCodeMappingState: {
          ...state.statusCodeMappingState,
          isLoading: false,
          isSuccess: true,
          isFailure: false,
          data: action.payload.body,
        },
      };

    case actionConstants.GET_PAYMENT_LINK_STATUS_CODE_FAILURE:
      return {
        ...state,
        statusCodeMappingState: {
          ...state.statusCodeMappingState,
          isLoading: false,
          isSuccess: false,
          isFailure: true,
        },
      };

    case actionConstants.GET_PAYMENT_LINK_STATUS_CODE_CLEAR:
      return {
        ...state,
        statusCodeMappingState: {
          ...initialState.statusCodeMappingState,
          data: [],
        },
      };

    case actionConstants.GET_PAYMENT_LINK_UDF_REQUEST:
      return {
        ...state,
        merchantAllUDFList: {
          ...state.merchantAllUDFList,
          isLoading: true,
          isSuccess: false,
          isFailure: false,
          errorCode: 0,
        },
      };
    case actionConstants.GET_PAYMENT_LINK_UDF_SUCCESS:
      return {
        ...state,
        merchantAllUDFList: {
          ...state.merchantAllUDFList,
          isLoading: false,
          isSuccess: true,
          isFailure: false,
          data: action.payload.body,
          // errorCode: action.payload.OpCode,
        },
      };

    case actionConstants.GET_PAYMENT_LINK_UDF_FAILURE:
      return {
        ...state,
        merchantAllUDFList: {
          ...state.merchantAllUDFList,
          isLoading: false,
          isSuccess: false,
          isFailure: true,
          // errorCode: action.payload.OpCode,
        },
      };

    case actionConstants.GET_PAYMENT_LINK_UDF_CLEAR:
      return {
        ...state,
        merchantAllUDFList: {
          ...initialState.merchantAllUDFList,
          data: [],
        },
      };
    case actionConstants.GET_EDGE_PAYMENT_LINK_UDF_REQUEST:
      return {
        ...state,
        merchantAllEdgeUDFList: {
          ...state.merchantAllEdgeUDFList,
          isLoading: true,
          isSuccess: false,
          isFailure: false,
          errorCode: 0,
        },
      };
    case actionConstants.GET_EDGE_PAYMENT_LINK_UDF_SUCCESS:
      return {
        ...state,
        merchantAllEdgeUDFList: {
          ...state.merchantAllEdgeUDFList,
          isLoading: false,
          isSuccess: true,
          isFailure: false,
          data: action.payload.body,
          // errorCode: action.payload.OpCode,
        },
      };

    case actionConstants.GET_EDGE_PAYMENT_LINK_UDF_FAILURE:
      return {
        ...state,
        merchantAllEdgeUDFList: {
          ...state.merchantAllEdgeUDFList,
          isLoading: false,
          isSuccess: false,
          isFailure: true,
          // errorCode: action.payload.OpCode,
        },
      };

    case actionConstants.GET_EDGE_PAYMENT_LINK_UDF_CLEAR:
      return {
        ...state,
        merchantAllEdgeUDFList: {
          ...initialState.merchantAllEdgeUDFList,
          data: [],
        },
      };

    case actionConstants.CUSTOMIZATION_PAYMENT_LINKS_TOGGLE_REQUEST:
      return {
        ...state,
        paymentLinksCustomizationState: {
          ...state.paymentLinksCustomizationState,
          isLoading: true,
          isSuccess: false,
          isFailure: false,
          responseCode: 0,
          responseMessage: '',
          isSubscribed: false,
        },
      };
    case actionConstants.CUSTOMIZATION_PAYMENT_LINKS_TOGGLE_SUCCESS:
      return {
        ...state,
        paymentLinksCustomizationState: {
          ...state.paymentLinksCustomizationState,
          isLoading: false,
          isSuccess: true,
          isFailure: false,
          responseCode: action.payload?.body?.response_code ?? 0,
          responseMessage: action.payload?.body?.response_message ?? '',
          isSubscribed: action.payload?.extra?.isSubscribeRequest ?? false,
        },
      };

    case actionConstants.CUSTOMIZATION_PAYMENT_LINKS_TOGGLE_FAILURE:
      return {
        ...state,
        paymentLinksCustomizationState: {
          ...state.paymentLinksCustomizationState,
          isLoading: false,
          isSuccess: false,
          isFailure: true,
          responseCode: action.payload?.body?.error_code ?? 0,
          responseMessage: action.payload?.body?.error_message ?? '',
        },
      };
    case actionConstants.CUSTOMIZATION_PAYMENT_LINKS_TOGGLE_CLEAR:
      return {
        ...state,
        paymentLinksCustomizationState: {
          ...initialState.paymentLinksCustomizationState,
          data: [],
        },
      };
    case actionConstants.CUSTOMIZATION_EDGE_PAYMENT_LINKS_TOGGLE_REQUEST:
      return {
        ...state,
        edgePaymentLinksCustomizationState: {
          ...state.edgePaymentLinksCustomizationState,
          isLoading: true,
          isSuccess: false,
          isFailure: false,
          responseCode: 0,
          responseMessage: '',
          enable: false,
        },
      };
    case actionConstants.CUSTOMIZATION_EDGE_PAYMENT_LINKS_TOGGLE_SUCCESS:
      return {
        ...state,
        edgePaymentLinksCustomizationState: {
          ...state.edgePaymentLinksCustomizationState,
          isLoading: false,
          isSuccess: true,
          isFailure: false,
          responseCode: action.payload?.body?.response_code ?? 0,
          responseMessage: action.payload?.body?.response_message ?? '',
          enable: action.payload?.extra?.enable ?? false,
        },
        merchantConfigList: {
          ...state.merchantConfigList,
          data: {
            ...state.merchantConfigList.data,
            isCustomizationEnabled: action.payload?.extra?.enable ?? false,
          },
        },
      };

    case actionConstants.CUSTOMIZATION_EDGE_PAYMENT_LINKS_TOGGLE_FAILURE:
      return {
        ...state,
        edgePaymentLinksCustomizationState: {
          ...state.edgePaymentLinksCustomizationState,
          isLoading: false,
          isSuccess: false,
          isFailure: true,
          responseCode: action.payload?.body?.error_code ?? 0,
          responseMessage: action.payload?.body?.error_message ?? '',
        },
      };
    case actionConstants.CUSTOMIZATION_EDGE_PAYMENT_LINKS_TOGGLE_CLEAR:
      return {
        ...state,
        edgePaymentLinksCustomizationState: {
          ...initialState.edgePaymentLinksCustomizationState,
          data: [],
        },
      };

    case actionConstants.UPDATE_ALL_UDF_REQUEST:
      return {
        ...state,
        updateAllUDFListState: {
          ...state.updateAllUDFListState,
          isLoading: true,
          isSuccess: false,
          isFailure: false,
          errorCode: 0,
          errorMessage: '',
        },
      };

    case actionConstants.UPDATE_ALL_UDF_SUCCESS:
      return {
        ...state,
        updateAllUDFListState: {
          ...state.updateAllUDFListState,
          isLoading: false,
          isSuccess: true,
          isFailure: false,
          data: action.payload.body,
        },
      };

    case actionConstants.UPDATE_ALL_UDF_FAILURE:
      return {
        ...state,
        updateAllUDFListState: {
          ...state.updateAllUDFListState,
          isLoading: false,
          isSuccess: false,
          isFailure: true,
          errorCode: action.payload?.body?.error_code ?? 0,
          errorMessage: action.payload?.body?.error_message ?? '',
        },
      };

    case actionConstants.UPDATE_ALL_UDF_CLEAR:
      return {
        ...state,
        updateAllUDFListState: {
          ...initialState.updateAllUDFListState,
          data: [],
        },
      };

    case actionConstants.UPDATE_ALL_EDGE_UDF_REQUEST:
      return {
        ...state,
        updateAllEdgeUDFListState: {
          ...state.updateAllEdgeUDFListState,
          isLoading: true,
          isSuccess: false,
          isFailure: false,
          errorCode: 0,
          errorMessage: '',
        },
      };

    case actionConstants.UPDATE_ALL_EDGE_UDF_SUCCESS:
      return {
        ...state,
        updateAllEdgeUDFListState: {
          ...state.updateAllEdgeUDFListState,
          isLoading: false,
          isSuccess: true,
          isFailure: false,
          data: action.payload.body,
        },
      };

    case actionConstants.UPDATE_ALL_EDGE_UDF_FAILURE:
      return {
        ...state,
        updateAllEdgeUDFListState: {
          ...state.updateAllEdgeUDFListState,
          isLoading: false,
          isSuccess: false,
          isFailure: true,
          errorCode: action.payload?.body?.error_code ?? 0,
          errorMessage: action.payload?.body?.error_message ?? '',
        },
      };

    case actionConstants.UPDATE_ALL_EDGE_UDF_CLEAR:
      return {
        ...state,
        updateAllEdgeUDFListState: {
          ...initialState.updateAllEdgeUDFListState,
          data: [],
        },
      };

    case actionConstants.GET_AVAILABLE_PAYMENT_MODE_LIST_REQUEST:
      return {
        ...state,
        availablePaymentModeListState: {
          ...state.availablePaymentModeListState,
          isLoading: true,
          isSuccess: false,
          isFailure: false,
          errorCode: 0,
          errorMessage: '',
        },
      };

    case actionConstants.GET_AVAILABLE_PAYMENT_MODE_LIST_SUCCESS:
      return {
        ...state,
        availablePaymentModeListState: {
          ...state.availablePaymentModeListState,
          isLoading: false,
          isSuccess: true,
          isFailure: false,
          data: action.payload.body,
        },
      };

    case actionConstants.GET_AVAILABLE_PAYMENT_MODE_LIST_FAILURE:
      return {
        ...state,
        availablePaymentModeListState: {
          ...state.availablePaymentModeListState,
          isLoading: false,
          isSuccess: false,
          isFailure: true,
          errorCode: action.payload?.body?.error_code ?? 0,
          errorMessage: action.payload?.body?.error_message ?? '',
        },
      };

    case actionConstants.GET_PAYMENT_LINK_CUSTOM_EMAIL_DATA_REQUEST:
      return {
        ...state,
        customEmailTemplateState: {
          ...state.customEmailTemplateState,
          isLoading: true,
          isSuccess: false,
          isFailure: false,
          errorCode: 0,
          errorMessage: '',
        },
      };

    case actionConstants.GET_PAYMENT_LINK_CUSTOM_EMAIL_DATA_SUCCESS:
      const { currentData, defaultData } = action.payload?.body
        ? (action.payload?.body as {
            currentData: Array<CustomEmailTemplateApiPayloadType> | [];
            defaultData: Array<CustomEmailTemplateApiPayloadType>;
          })
        : { currentData: [], defaultData: [] };

      const defaultDataObj = {};
      const currentDataObj = {};

      // Note: Mapping array into object with key `emailType`
      // and value as processed email template values object
      // which can be directly set into our components local state
      defaultData.map((defaultTemplateDetails) => {
        const { emailType, greeting, optionalDetails, optionalText, subject } =
          defaultTemplateDetails;
        // Note: From the API we are receiving optional details as comma separated values
        // below we are mapping that string into a object with key as `variableName` and boolean values
        const optionalDetailsFlags = {};
        (optionalDetails ? optionalDetails.split(',') : []).forEach(
          (variableName) => {
            optionalDetailsFlags[variableName] = true;
          }
        );
        // Note: Setting parsed data into the new default object created above
        defaultDataObj[emailType] = {
          greeting,
          optionalText: optionalText || '',
          subject,
          optionalDetailsFlags,
        };
        // Note: Setting parsed data into the new current object created above
        // there might be a use case when the current data array is empty
        // then we need to show default data in our UI and backend will also use the same approach
        currentDataObj[emailType] = {
          ...defaultDataObj[emailType],
          optionalDetailsFlags: {
            ...optionalDetailsFlags,
          },
        };
      });

      // Note: If data of any template is coming from the API in current data array
      // then below we are overwriting the default data stored in current object previously
      // with similar processing
      currentData.map((currentTemplateDetails) => {
        const { emailType, greeting, optionalDetails, optionalText, subject } =
          currentTemplateDetails;
        const optionalDetailsFlags = {};

        // Note: From the API we are receiving optional details as comma separated values
        // below we are mapping that string into a object with key as `variableName` and boolean values
        (optionalDetails ? optionalDetails.split(',') : []).forEach(
          (variableName: string) => {
            optionalDetailsFlags[variableName] = true;
          }
        );

        // Note: Overwriting the default data previously stored
        // with the current data received from the backend
        currentDataObj[emailType] = {
          greeting,
          optionalText: optionalText || '',
          subject,
          optionalDetailsFlags,
        };
      });

      return {
        ...state,
        customEmailTemplateState: {
          ...state.customEmailTemplateState,
          isLoading: false,
          isSuccess: true,
          isFailure: false,
          currentDataObj,
          defaultDataObj,
        },
      };

    case actionConstants.GET_PAYMENT_LINK_CUSTOM_EMAIL_DATA_FAILURE:
      return {
        ...state,
        customEmailTemplateState: {
          ...state.customEmailTemplateState,
          isLoading: false,
          isSuccess: false,
          isFailure: true,
          errorCode: action.payload?.body?.error_code ?? 0,
          errorMessage: action.payload?.body?.error_message ?? '',
        },
      };

    case actionConstants.GET_PAYMENT_LINK_CUSTOM_EMAIL_DATA_CLEAR:
      return {
        ...state,
        customEmailTemplateState: {
          ...customEmailTemplateState,
          currentDataObj: {},
          defaultDataObj: {},
        },
      };
    case actionConstants.GET_EDGE_PAYMENT_LINK_CUSTOM_EMAIL_DATA_REQUEST:
      return {
        ...state,
        customEdgeEmailTemplateState: {
          ...state.customEdgeEmailTemplateState,
          isLoading: true,
          isSuccess: false,
          isFailure: false,
          errorCode: 0,
          errorMessage: '',
        },
      };
    case actionConstants.GET_EDGE_PAYMENT_LINK_CUSTOM_EMAIL_DATA_FAILURE:
      return {
        ...state,
        customEdgeEmailTemplateState: {
          ...state.customEdgeEmailTemplateState,
          isLoading: false,
          isSuccess: false,
          isFailure: true,
          errorCode: action.payload?.body?.error_code ?? 0,
          errorMessage: action.payload?.body?.error_message ?? '',
        },
      };

    case actionConstants.GET_EDGE_PAYMENT_LINK_CUSTOM_EMAIL_DATA_CLEAR:
      return {
        ...state,
        customEdgeEmailTemplateState: {
          ...customEdgeEmailTemplateState,
          currentDataObj: {},
          defaultDataObj: {},
        },
      };
    case actionConstants.GET_EDGE_PAYMENT_LINK_CUSTOM_EMAIL_DATA_SUCCESS:
      return {
        ...state,
        customEdgeEmailTemplateState: {
          ...state.customEdgeEmailTemplateState,
          isLoading: false,
          isSuccess: true,
          isFailure: false,
          currentDataObj: { ...action.payload.body.currentData },
          defaultDataObj: { ...action.payload.body.defaultData },
        },
      };

    // Manage Custom Email Template Data
    case actionConstants.POST_MANAGE_PAYMENT_LINK_CUSTOM_EMAIL_REQUEST:
      return {
        ...state,
        manageCustomEmailTemplateState: {
          ...state.manageCustomEmailTemplateState,
          isLoading: true,
          isSuccess: false,
          isFailure: false,
          responseCode: 0,
          responseMessage: '',
        },
      };
    case actionConstants.POST_MANAGE_PAYMENT_LINK_CUSTOM_EMAIL_SUCCESS:
      return {
        ...state,
        manageCustomEmailTemplateState: {
          ...state.manageCustomEmailTemplateState,
          isLoading: false,
          isSuccess: true,
          isFailure: false,
          responseCode: action.payload?.body?.response_code ?? 0,
          responseMessage: action.payload?.body?.response_message ?? '',
        },
      };

    case actionConstants.POST_MANAGE_PAYMENT_LINK_CUSTOM_EMAIL_FAILURE:
      return {
        ...state,
        manageCustomEmailTemplateState: {
          ...state.manageCustomEmailTemplateState,
          isLoading: false,
          isSuccess: false,
          isFailure: true,
          responseCode: action.payload?.body?.error_code ?? 0,
          responseMessage: action.payload?.body?.error_message ?? '',
        },
      };

    case actionConstants.POST_MANAGE_PAYMENT_LINK_CUSTOM_EMAIL_CLEAR:
      return {
        ...state,
        manageCustomEmailTemplateState: {
          ...initialState.manageCustomEmailTemplateState,
        },
      };
    // FOR EDGE
    case actionConstants.POST_EDGE_MANAGE_PAYMENT_LINK_CUSTOM_EMAIL_REQUEST:
      return {
        ...state,
        manageEdgeCustomEmailTemplateState: {
          ...state.manageEdgeCustomEmailTemplateState,
          isLoading: true,
          isSuccess: false,
          isFailure: false,
          responseCode: 0,
          responseMessage: '',
        },
      };
    case actionConstants.POST_EDGE_MANAGE_PAYMENT_LINK_CUSTOM_EMAIL_SUCCESS:
      return {
        ...state,
        manageEdgeCustomEmailTemplateState: {
          ...state.manageEdgeCustomEmailTemplateState,
          isLoading: false,
          isSuccess: true,
          isFailure: false,
          responseCode: action.payload?.body?.response_code ?? 0,
          responseMessage: action.payload?.body?.response_message ?? '',
        },
      };

    case actionConstants.POST_EDGE_MANAGE_PAYMENT_LINK_CUSTOM_EMAIL_FAILURE:
      return {
        ...state,
        manageEdgeCustomEmailTemplateState: {
          ...state.manageEdgeCustomEmailTemplateState,
          isLoading: false,
          isSuccess: false,
          isFailure: true,
          responseCode: action.payload?.body?.error_code ?? 0,
          responseMessage: action.payload?.body?.error_message ?? '',
        },
      };

    case actionConstants.POST_EDGE_MANAGE_PAYMENT_LINK_CUSTOM_EMAIL_CLEAR:
      return {
        ...state,
        manageEdgeCustomEmailTemplateState: {
          ...initialState.manageEdgeCustomEmailTemplateState,
        },
      };

    case actionConstants.FETCH_LINKED_TXN_IDS_PL_REQUEST:
      return {
        ...state,
        fetchPaymentLinkDetails: {
          ...state.fetchPaymentLinkDetails,
          isLoading: true,
          isSuccess: false,
          isFailure: false,
          errorCode: 0,
        },
      };
    case actionConstants.FETCH_LINKED_TXN_IDS_PL_SUCCESS:
      return {
        ...state,
        fetchPaymentLinkDetails: {
          ...state.fetchPaymentLinkDetails,
          isLoading: false,
          isSuccess: true,
          isFailure: false,
          data: { ...action.payload.body },
          // errorCode: action.payload.OpCode,
        },
      };

    case actionConstants.FETCH_LINKED_TXN_IDS_PL_FAILURE:
      return {
        ...state,
        fetchPaymentLinkDetails: {
          ...state.fetchPaymentLinkDetails,
          isLoading: false,
          isSuccess: false,
          isFailure: true,
          // errorCode: action.payload.OpCode,
        },
      };

    case actionConstants.FETCH_LINKED_TXN_IDS_PL_CLEAR:
      return {
        ...state,
        fetchPaymentLinkDetails: {
          ...initialState.fetchPaymentLinkDetails,
          data: [],
        },
      };

    case actionConstants.GET_EDGE_MERCANT_CONFIG_REQUEST:
      return {
        ...state,
        merchantConfigList: {
          ...state.merchantConfigList,
          isLoading: true,
          isSuccess: false,
          isFailure: false,
          errorCode: 0,
        },
      };
    case actionConstants.GET_EDGE_MERCANT_CONFIG_SUCCESS:
      return {
        ...state,
        merchantConfigList: {
          ...state.merchantConfigList,
          isLoading: false,
          isSuccess: true,
          isFailure: false,
          data: action.payload.body,
          // errorCode: action.payload.OpCode,
        },
      };

    case actionConstants.GET_EDGE_MERCANT_CONFIG_FAILURE:
      return {
        ...state,
        merchantConfigList: {
          ...state.merchantConfigList,
          isLoading: false,
          isSuccess: false,
          isFailure: true,
          // errorCode: action.payload.OpCode,
        },
      };

    case actionConstants.GET_EDGE_MERCANT_CONFIG_CLEAR:
      return {
        ...state,
        merchantConfigList: {
          ...initialState.merchantConfigList,
          data: {},
        },
      };

    default:
      return state;
  }
}
